import { compose, contains, path, propEq, find } from 'ramda';
import { requiredContactEventTypes, notRequiredCompanyEventTypes } from 'constants/events';

export const getTranslateString = tookPlace => (
    tookPlace === 1 ? "events.shortResult" : "events.reason"
);

const getEventType = path(['contact', 'type']);
export const contactIsRequired = (values, path = getEventType) => contains(
    compose(Number, path)(values),
    requiredContactEventTypes
);

export const companyIsRequired = (values, path = getEventType) => !contains(
    compose(Number, path)(values),
    notRequiredCompanyEventTypes
);

const emptyEventConfig = {
    result: {},
};

export const getEventConfig = (eventType, eventTypes) => {
    return find(propEq('workCode', Number(eventType)))(eventTypes) || emptyEventConfig;
};
